import { render, staticRenderFns } from "./MemoView.vue?vue&type=template&id=1444c990"
import script from "./MemoView.vue?vue&type=script&lang=js"
export * from "./MemoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports